import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import * as CreDtos from "../CRE.dtos";
import { siteDataApi } from "../services/siteData";

import {
    SITE_DATA_REQUEST,
    siteDataRequestSuccess,
    siteDataRequestFailure
} from "../actions/sitedata.actions";


export const getSiteDataEpic = action$ =>
    action$
        .ofType(SITE_DATA_REQUEST)
        .mergeMap((action) =>
            siteDataApi
                .get()
                .mergeMap(response => {
                    return concat$(Observable.of(siteDataRequestSuccess(response.siteData)))
                })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(siteDataRequestFailure(error.responseStatus.message))
                )
        );




// WEBPACK FOOTER //
// ./src/epics/siteData.epic.ts